import axios from "axios";

const converterUrl = import.meta.env.VITE_AUDIO_CONVERTER_URL;
const converterToken = import.meta.env.VITE_AUDIO_CONVERTER_TOKEN;

function base64ToBlob(base64Content, mimeType) {
  const byteStr = atob(base64Content);
  const bytes = new Uint8Array(byteStr.length);
  for (let i = 0; i < byteStr.length; i++) bytes[i] = byteStr.charCodeAt(i);
  return new Blob([bytes], { type: mimeType });
}

function uint8ToBase64(uint8Array) {
  let binary = "";
  const chunkSize = 0x8000; // 32KB
  for (let i = 0; i < uint8Array.length; i += chunkSize) {
    binary += String.fromCharCode.apply(null, uint8Array.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}

// iOS Safari can't play back webm recordings, so any recorded audio is run through
// a conversion service to normalize it to AAC/m4a before it's uploaded as a blob.
export async function convertAudioToM4a(base64Content, mimeType) {
  const file = base64ToBlob(base64Content, mimeType);
  const formData = new FormData();
  formData.append("file", file, "recording");

  const response = await axios.post(converterUrl, formData, {
    headers: { Authorization: `Bearer ${converterToken}` },
    responseType: "arraybuffer",
  });

  return {
    base64: uint8ToBase64(new Uint8Array(response.data)),
    mimeType: "audio/mp4",
  };
}
